export const getPedido = ({ pedido }) => pedido;

export const getPagamento = ({ pagamento }) => pagamento;

export const getPagamentosHistorico = ({ pagamentosHistorico }) =>
  pagamentosHistorico;

export const getPedidos = ({ pedidos }) => pedidos;
